import { UnexpectedOrderStatus } from './error';
/**
 * Zombie statuses still hanging around in our database
 */
export var LegacyOrderStatus;
(function (LegacyOrderStatus) {
    /**
     * Unpaid order status from when we didn't take credit card authorizations
     */
    LegacyOrderStatus["AwaitingEstimatePayment"] = "awaiting estimate payment";
})(LegacyOrderStatus || (LegacyOrderStatus = {}));
/**
 * The stages of an order's lifecycle
 */
export var OrderStatus;
(function (OrderStatus) {
    /**
     * Order is awaiting payment authorization of the estimate amount
     */
    OrderStatus["AwaitingEstimateAuthorization"] = "awaiting estimate authorization";
    /**
     * Order is awaiting approval by a clerk that the order can be serviced
     */
    OrderStatus["AwaitingApproval"] = "awaiting approval";
    /**
     * The order has been returned to the customer as further clarification or data is required to process the order
     */
    OrderStatus["AwaitingMoreInformation"] = "awaiting more information";
    /**
     * Order is currently being fulfilled
     */
    OrderStatus["InProgress"] = "in progress";
    /**
     * Order is awaiting settlement of the estimate payment authorization
     */
    OrderStatus["AwaitingEstimateSettlement"] = "awaiting estimate settlement";
    /**
     * Order is awaiting payment of the balance amount (i.e. the difference between the final amount due and the estimate
     * payment)
     */
    OrderStatus["AwaitingBalancePayment"] = "awaiting balance payment";
    /**
     * Order has been completed and the product delivered to the customer
     */
    OrderStatus["Completed"] = "completed";
    /**
     * Order has been canceled prior to completion
     */
    OrderStatus["Canceled"] = "canceled";
    /**
     * Access to the order has been revoked after completion
     */
    OrderStatus["AccessRevoked"] = "access revoked";
})(OrderStatus || (OrderStatus = {}));
/**
 * When an order has one of these statuses, it is not expected to be shown on the UI.
 */
export const ORDER_STATUSES_TO_BE_HIDDEN_FROM_USERS = [
    // This status is not shown on the UI because when an order has it, we're not yet sure if it's been successfully
    // placed (i.e. its credit card has been charged).
    OrderStatus.AwaitingEstimateSettlement,
    // This status is not shown on the UI because orders which have not been successfully placed (i.e. where
    // a credit card may have declined) will have this status.
    OrderStatus.AwaitingEstimateAuthorization,
];
/**
 * When an order has one of these statuses, it is considered open.
 * Orders awaiting customer action are excluded as they use their own status.
 * InProgress includes Awaiting Assignment and Awaiting Transcript Confirmation
 * because these are workflow statuses.
 */
export const OPEN_ORDER_STATUSES = [OrderStatus.AwaitingApproval, OrderStatus.InProgress];
/**
 * When an order has one of these statuses, it is considered closed.
 */
export const CLOSED_ORDER_STATUSES = [
    OrderStatus.Completed,
    OrderStatus.Canceled,
    OrderStatus.AccessRevoked,
];
/**
 * When an order has one of these statuses, it is awaiting customer action.
 */
export const AWAITING_CUSTOMER_ACTION_ORDER_STATUSES = [
    OrderStatus.AwaitingMoreInformation,
    OrderStatus.AwaitingBalancePayment,
];
export function assertOrderStatus(status, expectedStatus, message) {
    const expectedStatuses = Array.isArray(expectedStatus) ? expectedStatus : [expectedStatus];
    if (!expectedStatuses.includes(status)) {
        throw typeof message === 'object'
            ? message
            : new UnexpectedOrderStatus(message !== null && message !== void 0 ? message : `Expected order status to be ${expectedStatuses.join(' or ')}, but received ${status}`);
    }
}
